import { Component, Input, OnInit } from "@angular/core";
import { LoadingController } from "@ionic/angular";
import { Navigator } from "src/app/components/menu/navigator";
import { ConfigService } from "src/app/services/config/config.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { WebcontentService } from "src/app/services/webcontent/webcontent.service";

@Component({
  selector: 'app-player-protection',
  templateUrl: './player-protection.component.html',
  styleUrls: ['./player-protection.component.scss'],
})

export class PlayerProtectionComponent implements OnInit {

  @Input() path: string;
  public customer: any = {};
  public isAuthenticated: boolean;
  public lastIPAddress: string;
  public loading: any;

  public timeStampFlag: boolean = true;
  public title: string;
  
  constructor(
    public configService: ConfigService,
    public loadingController: LoadingController,
    public navigator:Navigator,
    public userSession: UserSessionService,
    public webcontentService: WebcontentService,
  ){
    this.userSession.getCustomer().subscribe((customer) => this.customer = customer);
  }

  ngOnInit(): void{
    this.userSession.isAuthenticated().then((res)=> this.isAuthenticated = res);
    this.lastIPAddress = localStorage.getItem('lastIPAddress');

    const url: string = this.getURL();
    this.webcontentService.updateExternalLink(url);
    if(this.path === "rglogo"){
      this.title = this.configService.getExternalLinks().payload.filter(link => link?.code == "rg_popover")[0]?.title ?? 'Responsible Gaming';
    }else {
      this.title = this.configService.getExternalLinks().payload.filter(link => link?.code == "player_protection")[0]?.title ?? 'Player Protection';
    }
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: 'Please wait loading...',
      duration: 1200,
    });
  
    this.loading.present();
  }

  public getURL(): string{
    if(this.path === "rglogo"){
      return this.configService.getExternalLinks().payload.filter(link => link?.code == "rg_popover")[0]?.url ?? 'rg_popover';
    }else {
      return this.configService.getExternalLinks().payload.filter(link => link?.code == "player_protection")[0]?.url ?? 'player_protection';
    }
 
  }

  public onBack = () => {
    this.navigator.back();
  }
}